import { render, staticRenderFns } from "./settle.vue?vue&type=template&id=670ec780&"
import script from "./settle.vue?vue&type=script&lang=js&"
export * from "./settle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports